import { render, staticRenderFns } from "./E2000Plug.vue?vue&type=template&id=0b2c48e3"
import script from "./E2000Plug.vue?vue&type=script&lang=js"
export * from "./E2000Plug.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports